/**
 * node_modules
 */
import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"

/**
 * styles
 */
import * as styles from "@features/Home/Business/Business.module.scss"

/**
 * components
 */
import { Button } from "@components/Button"
import { ResponsiveImage } from "@components/ResponsiveImage"

/**
 * @function Business
 * @description HOME/Businessセクション
 */
export const Business = () => {
  /**
   * query
   */
  const data: Queries.HomeBusinessDataQuery = useStaticQuery(graphql`
    query HomeBusinessData {
      mobile: file(relativePath: { eq: "images/home/business.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      desktop: file(relativePath: { eq: "images/home/business.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      allDataJson {
        nodes {
          home {
            business {
              heading
              texts
              button {
                text
                url
              }
            }
          }
        }
      }
    }
  `)
  const jsonData = data.allDataJson.nodes
    .filter((item) => item.home !== null)
    .map((item) => item.home)
    .find((home) => home !== null)

  return (
    <section className={styles["business"]}>
      <div className={styles["business_inner"]}>
        <div className={styles.business_text}>
          <h2>{jsonData!.business!.heading!}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: jsonData!.business!.texts!,
            }}
          />
          <div className={styles["business_button"]}>
            <Button
              text={jsonData!.business!.button!.text!}
              to={jsonData!.business!.button!.url!}
              icon="arrow"
            />
          </div>
        </div>
        <div className={styles.business_media}>
          <ResponsiveImage
            mobileImage={getImage(data.mobile!.childImageSharp!.gatsbyImageData)}
            desktopImage={getImage(data.desktop!.childImageSharp!.gatsbyImageData)}
          />
        </div>
      </div>
    </section>
  )
}
